import PropTypes from "prop-types";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import InputText from "../../inputFields/InputText";
import DataType from "../../../../../lib/model/types/DataType";
import React from "react";
import InputDateTimePicker from "../../inputFields/InputDateTimePicker";
import Checkbox from "../../../../../lib/components/checkbox/Checkbox";
import GF from "../../../../../lib/utils/GF";
import shortid from "shortid";
import InputSearchDropDown from "../../inputFields/dropdown/InputSearchDropDown";

class ValueField extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      fieldDef: GF.getValue(this.props.fieldDef)
    }
  }

  onChange(e, id, value) {
    if (GF.checkNotNull(this.props.fieldPredicateRef) && GF.checkNotNull(this.props.fieldPredicateRef.current)) {
      this.props.fieldPredicateRef.current.onFieldValueChange(e, value);
    }
    if (GF.checkNotNull(this.props.onChange)) {
      this.props.onChange(e, id, value);
    }
  }

  onDateTimeChange(e, id, value) {
    this.props.fieldPredicateRef.current.onFieldValueChange(null, null, value);
  }

  initField() {
    let field;
    let fieldLabel = this.state.fieldDef.label;
    if (GF.checkNotNull(this.state.fieldDef)) {
      switch (this.state.fieldDef.type.type) {
        case DataType.BOOLEAN:
          field = <Checkbox
            labelElement={fieldLabel}
            key={shortid()}
            checked={false}
            onChange={(e, id, value) => this.onChange(e, id, value)}/>;
          break;
        case DataType.INTEGER:
        case DataType.FLOAT:
        case DataType.STRING:
          field = <InputText
            size={'small'}
            labelElement={fieldLabel}
            onChange={(e, id, value) => this.onChange(e, id, value)} defaultValue={this.props.value}/>;
          break;
        case DataType.DATETIME:
          field = <InputDateTimePicker
            size={'small'}
            labelElement={fieldLabel}
            defaultValue={this.props.value}
            useTime={false}
            canChooseUseTime={true}
            onChange={(e, id, value) => this.onDateTimeChange(e, id, value)}/>;
          break;
        case DataType.ENUM:
          field = this.buildInputDropDown(fieldLabel);
          break;
        case DataType.DATA_EXT:
        case DataType.OBJECT:
        default:
          field = <InputText
            size={'small'}
            labelElement={fieldLabel}
            onChange={(e, id, value) => this.onChange(e, id, value)}
            defaultValue={this.props.value}/>;
          break;
      }
    } else {
      field =
        <InputText size={'small'} labelElement={fieldLabel} onChange={(e, id, value) => this.onChange(e,
          id, value)} defaultValue={this.props.value}/>;
    }
    return field;
  }

  buildInputDropDown(fieldLabel) {
    let menuItems = [];
    for (let index in this.state.fieldDef.type.valueMap) {
      let element = this.state.fieldDef.type.valueMap[index];
      menuItems.push({id: index, label: element});
    }
    return <InputSearchDropDown size={'small'}
                                labelElement={fieldLabel}
                                onChange={(e, id, value) => this.onChange(e, id, value.id)}
                                defaultValue={this.props.value}>
      {menuItems}
    </InputSearchDropDown>;
  }

  updateFieldType(e, option) {
    this.state.fieldDef = this.props.fieldDefs[option];
    this.setState(this.state);
  }

  render() {
    return <div className='w-full'>{this.initField()}</div>
  }
}

ValueField.propTypes = {
  labelElement: PropTypes.string,
  value: PropTypes.string,
  fieldPredicateRef: PropTypes.object,
  className: PropTypes.string,
  fieldDef: PropTypes.object,
  fieldDefs: PropTypes.object,
  onChange: PropTypes.func
}
export default ValueField;
